import React from "react"
import { MainCP } from "../../Components/nueva-constitucion/MainCP"

const ViewNuevaConstitucion: React.FC = () => <MainCP/>

export default ViewNuevaConstitucion;